import React from 'react';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { buildClassName } from 'utils/build-class-name';
import { testIds } from 'constants/test-constants';
/**
 * @internal
 * Generic chevron icon component used by navigation components.
 * This component is an internal implementation detail of the navigation module.
 * Do not import or use this component directly from outside the navigation module.
 */

interface ChevronIconProps {
  isExpanded?: boolean;
  className?: string;
  width?: number;
  height?: number;
  styleOverrides?: {
    icon?: string;
  };
}

export const ChevronIcon = ({ 
  isExpanded = false,
  className,
  width = 12,
  height = 12,
  styleOverrides = {},
}: ChevronIconProps) => {
  return (
    <ExpandMoreOutlinedIcon 
      className={buildClassName(className, styleOverrides.icon)}
      sx={{
        width: width,
        height: height,
        color: 'currentColor !important',
        '& path': {
          fill: 'currentColor !important',
        },
        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 0.2s ease-in-out',
      }}
      data-testid={testIds.expandIcon}
    />
  );
}; 